import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { LearnAboutFiasResourcesPage } from './LearnAboutFiasResourcesPage';

export function LearnAboutFiasArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<LearnAboutFiasResourcesPage />} />
      </Routes>
    </ArcheLayout>
  );
}
